import styled from 'styled-components'

type ContainerProps = {
  background: string
}

export const Container = styled.div<ContainerProps>`
  border-radius: 8px;
  background-color: ${({ background }) => background};
  align-items: center;
  display: flex;
  justify-content: center;
  width: 40px;
  height: 40px;
`
